(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["the-four-c"] && !Shopify.designMode) return;
  try {
    

let getButtonContainers = document.getElementsByClassName("tab-group-button-container");
let buttonContainersArray = Array.from(getButtonContainers);

let getButtons = document.getElementsByClassName("tab-group-button");
let buttonsArray = Array.from(getButtons);

let getTabContent = document.getElementsByClassName("tab-group-content");
let tabContentArray = Array.from(getTabContent);

buttonsArray.forEach(el => {
  el.addEventListener('click', function(event) {
    event.preventDefault();
    buttonContainersArray.forEach(el => el.classList.remove('bg-tan'));
    this.parentElement.classList.add("bg-tan");

    buttonsArray.forEach(el => el.classList.remove('active'));
    this.classList.add("active");
    this.blur();

    tabContentArray.forEach(el => el.classList.remove('show'));
    let selectedBtn = document.querySelector(this.dataset.target);
    selectedBtn.classList.add("show");
  })
})


  } catch(e) { console.error(e); }
})();
})();
